import { IAccountDetails } from "./main.interfaces";

export function createEmptyUserObject(): IAccountDetails {
  return {
    username: "",
    password: "",
    organization: "",
    email: "",
    roles: []
  };
}
